export default __webpack_public_path__ + "static/badge_aws_sa_associate-67c4a073948960b7deb0e9b4e41fc57a.png";